import {
  initHeaderAnnouncement,
  initHeaderSearch,
  initHeaderNav,
  //   initOffcanvasSidebar,
  initHeaderShrinking,
} from "Components/header";
import { Breakpoints } from "Components/breakpoints";

export function initHeader() {
  const header = document.querySelector("header.header");

  if (!header) {
    return;
  }

  const headerNav = initHeaderNav(header);
  //   const OffcanvasSidebar = initOffcanvasSidebar(header);
  const announcement = initHeaderAnnouncement(header);
  const headerSchrink = initHeaderShrinking(header, announcement);
  const search = initHeaderSearch(header);

  const breakpointsCallbacks = setBreakpointsHandlers([
    headerNav,
    headerSchrink,
  ]);

  function setBreakpointsHandlers(modules = []) {
    if (!Array.isArray(modules)) {
      return {};
    }

    return modules.reduce((result, mod) => {
      const breakpoints = mod?.breakpoints ?? false;
      if (!breakpoints) {
        return result;
      }
      try {
        Object.keys(breakpoints).forEach((key) => {
          if (typeof breakpoints[key] !== "function") {
            return result;
          }

          if (result[key] !== undefined && Array.isArray(result[key])) {
            result[key].push(breakpoints[key]);
          } else {
            result[key] = [breakpoints[key]];
          }
        });
      } catch (error) {
        console.error(error);
      }
      return result;
    }, {});
  }

  doBreakpointCallbacks(Breakpoints.getMatches(), breakpointsCallbacks);

  function doBreakpointCallbacks(matches = {}, callbacks = []) {
    try {
      const header_matches = Object.keys(matches).filter((key) => {
        return !!matches[key] && !!callbacks[key];
      });

      header_matches.forEach((key) => {
        callbacks[key]?.forEach((cb) => cb());
      });
    } catch (error) {}
  }

  Breakpoints.domElem.addEventListener("mediaChange", function (e) {
    const matches = e.detail.matches || {};
    doBreakpointCallbacks(matches, breakpointsCallbacks);
  });
}
